<template>
  <div class="agents">

    <div class="title-button">

      <h1>Agents</h1>

      <router-link to="/agents/create" class="button p-3" v-if="userRole ==1">New agent</router-link>

    </div>

    <div class="box">

      <form @submit.stop.prevent="doSearch" class="box__header form--inline">
        <input v-model="quickSearch" type="search" placeholder="Quick search">
        <button class="button button--small" type="submit">Search</button>
      </form>
      <div class="row">
        <div class="col-md-12 table-responsive">
          <vdtnet-table
            ref="table"
            :fields="fields"
            :opts="options"
            @edit="doAlertEdit"
            @sendResetPasswordLink="doSendResetPasswordLink"
            @delete="doAlertDelete"
            >
          </vdtnet-table>
        </div>
      </div>

    </div><!-- box -->

  </div>
</template>

<script>
import 'datatables.net'
import VdtnetTable from 'vue-datatables-net'

export default {
  name: 'agents',
  components: {
    VdtnetTable
  },
  computed: {
    userRole() {
      return localStorage.getItem("user_role");
    }
  },
  data() {
    return {
      options: {
        ajax: {
          url: this.$api + 'agents/table',
          headers: {
            'Accept': 'application/json',
            'Authorization': localStorage.getItem('token')
          }
        },
        responsive: false,
        processing: true,
        searching: true,
        searchDelay: 1500,
        destroy: true,
        ordering: true,
        lengthChange: true,
        serverSide: true,
        dom: 'rtlip',
        autoWidth: false,
        lengthMenu: [ [25, 50, 100, 500], [25, 50, 100, 500] ],
        pageLength: 25,
        order: [[4, 'desc']],
      },
      fields: {
        abta: { label: 'ABTA no.'},
        name: { label: 'Name'},
        postcode: { label: 'Postcode'},
        actions: {
          sortable: false,
          label: ' ',
          className: 'table-action',
          render: (data, type, row) => {
            return `<a href="/agent/edit/${ row.id }" data-action="edit" class="icon icon--more">Edit</a>`
          }
        },
        delete: {
          sortable: false,
          label: ' ',
          className: 'table-action',
          render: (data, type, row) => {
            if (this.userRole == 1) {
              return `<a href="/agent/delete/${ row.id }" data-action="delete" class="icon icon--delete">Delete</a>`
            } else {
              return ''
            }
          }
        },
        phone_number: {
          label: ' ',
          sortable: false,
          className: 'table-action',
          render: (data, type, row) => {
            if (row.email) {
              return `<a href="/agent/edit/${row.id}" data-action="sendResetPasswordLink" class="btn btn-sm btn-warning" title="Send Password Reset link">
                  <svg width="20px" height="20px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <title>Send Reset password link</title>
                  <path d="M21 8.5V6C21 4.89543 20.1046 4 19 4H5C3.89543 4 3 4.89543 3 6V11C3 12.1046 3.89543 13 5 13H10.875M19 14V12C19 10.8954 18.1046 10 17 10C15.8954 10 15 10.8954 15 12V14M14 20H20C20.5523 20 21 19.5523 21 19V15C21 14.4477 20.5523 14 20 14H14C13.4477 14 13 14.4477 13 15V19C13 19.5523 13.4477 20 14 20Z" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <circle cx="7.5" cy="8.5" r="1.5" fill="#000000"/>
                  <circle cx="12" cy="8.5" r="1.5" fill="#000000"/>
                  </svg>
                </a>`
            } else {
              return null
            }
          }
        },
      },
      quickSearch: ''
    }
  },
  methods: {
    doSearch() {
      this.$refs.table.search(this.quickSearch)
    },
    doAlertEdit(data) {
      this.$router.push({ name: 'agent-edit', params: { id: data.id }})
    },
    doAlertDelete(data) {
      this.$store.dispatch('setLoadStatus')
      fetch(this.$api + 'agents/' + data.id + '/delete', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'Authorization': localStorage.getItem('token')
        }
      })
      .then(res => res.json())
      .then(response => {
        this.errors = response.errors
        if(response.success == true) {
          this.$refs.table.reload()
          this.$notify({
            type: 'success',
            title: response.message
          });
        } else if (response.errors) {
          this.$notify({
            type: 'error',
            title: response.message
          });
        } else {
          this.$notify({
            type: 'error',
            title: response.Error
          });
        }
        this.$store.dispatch('setLoadStatus')
      });
    },
    doSendResetPasswordLink(data) {
      this.$store.dispatch('setLoadStatus')
      fetch(this.$api + 'agents/password/reset-link', {
          method: 'POST',
          body: JSON.stringify({
            email: data.email  
          }),
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': localStorage.getItem('token')
          }
      })
      .then(res => res.json())
      .then(response => {
          this.errors = response.errors
          if(response.status) {
              this.$notify({
                  type: 'success',
                  title: response.message
              });
          } else {
              this.$notify({
                  type: 'error',
                  title: response.message
              });
          }
          this.$store.dispatch('setLoadStatus')
      });
    }
  }
}

</script>
